import Text from './Text';

export interface IRadioOption {
  label: string;
  id: number;
}
const opts: IRadioOption[] = [
  {
    label: 'Occasion',
    id: 0,
  },
  {
    label: 'Neuf',
    id: 1,
  },
];

const CheckBox = ({
  options = opts,

  onChange,
  value,
  displayLabel,
}: {
  options?: IRadioOption[];
  displayLabel: string;
  onChange: (opt: number | undefined) => void;
  value?: number[];
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(+e.target.value);
  };

  return (
    <div className="w-full ">
      <Text
        as="span"
        text={displayLabel}
        className="text-sm text-gray-500 font-bold my-2"
      />
      <div className="flex mt-3">
        {options.map((plan) => (
          <div key={plan.id} className="flex items-center justify-center mr-4">
            <input
              onChange={handleChange}
              id={plan.id.toString()}
              checked={!!value?.includes(plan.id)}
              type="checkbox"
              value={plan.id.toString()}
              className="w-4 h-4 accent-primary text-primary bg-gray-100 rounded border-gray-300    dark:bg-gray-700 dark:border-gray-600"
            ></input>
            <label
              htmlFor="inline-checkbox"
              className="ml-2 text-sm font-normal text-gray-600"
            >
              {plan.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckBox;
